import { useFormikContext } from "formik";
import { isEmpty } from "lodash-es";
import { Alert, AlertList, AlertWrapper } from "melco-ui";
import { useTranslation } from "react-i18next"

export const DisplayCustomThreadFormErrors: React.FC = () => {

    const { t } = useTranslation();
    const { status } = useFormikContext();

    if (!status || isEmpty(status.errorMessages)) {
        return null
    }

    return (<>
        <AlertWrapper>
            <Alert
                message={t('global.error.form.title')}
                type="error"
                withBackground
                description={<>{
                    !isEmpty(status.globalErrorMessages) && (
                        <AlertList >
                            {
                                status.globalErrorMessages.map((error: string) => (
                                    <li key={error}>{error}</li>
                                ))
                            }
                        </AlertList>
                    )
                }
                    {
                        !isEmpty(status.fieldErrorMessages) && (
                            <AlertList >
                                {status.fieldErrorMessages?.file_name?.[0] &&
                                    <li key={status.fieldErrorMessages?.file_name?.[0]}>
                                        {status.fieldErrorMessages?.file_name?.[0]}
                                    </li>
                                }
                                {status.fieldErrorMessages?.thread_chart_color_list?.[0] &&
                                    <li key={status.fieldErrorMessages?.thread_chart_color_list?.[0]}>
                                        {status.fieldErrorMessages?.thread_chart_color_list?.[0]}
                                    </li>
                                }

                                {status.fieldErrorMessages?.product_list?.[0] &&
                                    <li key={status.fieldErrorMessages?.product_list?.[0]}>
                                        {status.fieldErrorMessages?.product_list?.[0]}
                                    </li>
                                }
                                {status.fieldErrorMessages?.thread_chart_color_list?.[0] && status.fieldErrorMessages?.thread_chart_color_list?.[0]?.supplier_name &&
                                    <li key={status.fieldErrorMessages?.thread_chart_color_list[0].supplier_name}>
                                        {status.fieldErrorMessages?.thread_chart_color_list[0].supplier_name}
                                    </li>
                                }
                            </AlertList>
                        )
                    }
                </>
                }
            />
        </AlertWrapper>
    </>)
}